import * as Yup from 'yup';
import {
	Card,
	CardActions,
	CardContent,
	CardHeader,
	CircularProgress,
	Grid,
	IconButton,
	TextField,
	Typography,
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { Button } from 'src/components';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import authActions from 'src/store/Auth/actions';
import useStyles from './styles';

function Login() {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const notification = useSelector((state: RootState) => state.notification);

	const login = (username: string, password: string) =>
		dispatch(authActions.login(username, password));
	const isLoading = useSelector((state: RootState) => state.auth.isLoading);

	const [showPass, setShowPass] = useState(false);
	const { errors, handleBlur, handleChange, submitForm, touched, values } =
		useFormik({
			enableReinitialize: true,
			initialValues: {
				password: '',
				username: '',
			},
			onSubmit: (values) => {
				login(values.username, values.password);
			},
			validationSchema: Yup.object().shape({
				password: Yup.string().required('Password es requerido'),
				username: Yup.string().required('Usuario es requerido'),
			}),
		});

	const handleMouseDownPassword = (event: any) => {
		event.preventDefault();
	};

	useEffect(() => {
		if (notification.open) {
			enqueueSnackbar(notification.message, {
				variant: notification.variant,
			});
		}
	}, [notification]);

	return (
		<div className={classes.container}>
			<Card
				className={classes.card}
				variant={'outlined'}
				component={"form"}
				onSubmit={e => {
					e.preventDefault();
					submitForm();
				}}
			>
				<CardHeader
					title={
						<Typography variant={'h3'}>
							{' '}
							Capacitaciones CCN{' '}
						</Typography>
					}
				/>

				<CardContent>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<TextField
								autoComplete={'off'}
								error={
									Boolean(errors.username) &&
									Boolean(touched.username)
								}
								fullWidth
								helperText={
									Boolean(errors.username) &&
									Boolean(touched.username)
								}
								label={'Usuario'}
								name={'username'}
								onBlur={handleBlur}
								onChange={handleChange}
								value={values.username}
								variant={'outlined'}
							/>
						</Grid>

						<Grid item xs={12}>
							<TextField
								InputProps={{
									endAdornment: (
										<IconButton
											aria-label={
												'toggle password visibility'
											}
											edge={'end'}
											onClick={() => {
												setShowPass(!showPass);
											}}
											onMouseDown={
												handleMouseDownPassword
											}
										>
											{showPass ? (
												<Visibility />
											) : (
												<VisibilityOff />
											)}
										</IconButton>
									),
								}}
								autoComplete={'off'}
								error={Boolean(
									errors.password && touched.password,
								)}
								fullWidth
								helperText={
									Boolean(errors.password) &&
									Boolean(touched.password)
								}
								label={'Contraseña'}
								name={'password'}
								onChange={handleChange}
								type={showPass ? 'text' : 'password'}
								value={values.password}
								variant={'outlined'}
							/>
						</Grid>
					</Grid>
				</CardContent>

				<CardActions className={classes.actions}>
					{/* <a href="/recover_password">
                        Recuperar contraseña
                    </a> */}
					<div />

					<Button
						className={classes.button}
						color={'secondary'}
						disabled={isLoading}
						variant={'contained'}
						type="submit"
					>
						{isLoading ? (
							<CircularProgress size={26} />
						) : (
							'Iniciar sesión'
						)}
					</Button>
				</CardActions>
			</Card>
		</div>
	);
}

export default Login;
